// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__vDBPO","medium":"Logo_medium__orAUa","large":"Logo_large__xuz7y","icon":"Logo_icon__ndBv7","text":"Logo_text__606V2"};